<template>
  <div id="about">
    <b-row>
      <b-col cols="12" md="6">
        <VueMarkdown
          class="markdown"
          :source="markdownText1"
          :anchor-attributes="anchorAttributes"
        />
      </b-col>
      <b-col cols="12" md="6">
        <VueMarkdown
          class="markdown"
          :source="markdownText2"
          :anchor-attributes="anchorAttributes"
        />
      </b-col>
    </b-row>
    <div class="footer">
      <b-col>Ver1.2(2026-10-19)</b-col>
      <b-col>Powered by <i class="fab fa-vuejs"></i></b-col>
    </div>
    <!-- <footer class="footer">
      <h5>Ver1.1(2022/09/27)</h5>
      <h5>Powered by <i class="fab fa-vuejs"></i></h5>
    </footer> -->
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";
import Global from "@/components/Global.vue";

export default {
  name: "About",
  components: {
    VueMarkdown
  },
  computed: {
    debug: function() {
      return Global.debug;
    }
  },
  data: function() {
    return {
      anchorAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow"
      },
      markdownText1: `
### 理由
個人是能接受新意義的詞，但不希望原本的習慣用語被取代
- [Google「繁中翻譯」中國化 查video竟翻成視頻](https://www.setn.com/News.aspx?NewsID=746793)
### 圖片來源
- [[閒聊] 支語警察是誰畫的？](https://disp.cc/b/ACG/cyOD)
- [[問卦] 支語警察怎麼知道哪些詞是支語](https://pttgopolitics.com/gossiping/M.1600605811.A.C2F.html)
- [支語警察總整理](https://www.dcard.tw/f/meme/p/237540084)
- [情報】支語警察系列支援包（圖多注意](https://forum.gamer.com.tw/Co.php?bsn=60076&sn=71978794)
`,
      markdownText2: `
### 實作方法
[如何當稱職的支語警察？](http://gitqwerty777.github.io/foreign-language-police/)
因為寫得很醜，就不開源了
### 關於作者
- <i class="fab fa-github"></i> [Github](https://github.com/gitqwerty777)
- <i class="fas fa-home"></i> [主頁](http://qwerty777.me/)
      `
    };
  }
};
</script>

<style scoped>
#about {
  grid-area: c;
  background-color: #b38900;

  text-align: left;
  padding: 50px;
  min-height: calc(100vh - 60px);
}

.footer {
  position: absolute;
  bottom: 5px;
  justify-content: center !important;
  align-items: center !important;
}

@media (max-width: 768px) {
  #about {
    padding: 20px;
  }
  .footer {
    position: static;
    margin-top: 20px;
  }
  .markdown ::v-deep a {
    word-break: break-all;
  }
}
</style>
